import { FC, MouseEvent } from 'react';

/** id of the `<main>` landmark every page template renders as its content region. */
export const MAIN_CONTENT_ID = 'main-content';

/** Marks where the skip link lands (e.g. the chat input). One per page; defaults to `<main>`. */
export const SKIP_TARGET_ATTR = 'data-skip-target';

interface SkipLinkProps {
  targetId?: string;
  label?: string;
}

/** First focusable element on the page, visible only when focused. Skips the header navigation. */
export const SkipLink: FC<SkipLinkProps> = ({ targetId = MAIN_CONTENT_ID, label = 'Skip to main content' }) => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    // Go to the page's skip target if there is one, otherwise `<main>`.
    const target = document.querySelector<HTMLElement>(`[${SKIP_TARGET_ATTR}]`) ?? document.getElementById(targetId);
    if (!target) return;

    // Move focus without pushing the hash into the SPA history.
    event.preventDefault();
    target.focus();
    target.scrollIntoView();
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="bg-theme-white text-theme-dark-green border-theme-dark-green focus-visible:outline-fletchers-green-500 fixed top-2 left-2 z-[10001] -translate-y-[200%] rounded-md border px-4 py-2 text-sm font-semibold shadow-lg transition-transform focus:translate-y-0"
    >
      {label}
    </a>
  );
};
